/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MuDataProcessingModelsFuelTankLevel
 */
export interface MuDataProcessingModelsFuelTankLevel {
    /**
     * 
     * @type {Date}
     * @memberof MuDataProcessingModelsFuelTankLevel
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof MuDataProcessingModelsFuelTankLevel
     */
    level?: number;
}

export function MuDataProcessingModelsFuelTankLevelFromJSON(json: any): MuDataProcessingModelsFuelTankLevel {
    return MuDataProcessingModelsFuelTankLevelFromJSONTyped(json, false);
}

export function MuDataProcessingModelsFuelTankLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuDataProcessingModelsFuelTankLevel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': (new Date(json['time'])),
        'level': !exists(json, 'level') ? undefined : json['level'],
    };
}

export function MuDataProcessingModelsFuelTankLevelToJSON(value?: MuDataProcessingModelsFuelTankLevel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': (value.time.toISOString()),
        'level': value.level,
    };
}


